import React from "react";
import { RouterPrompt } from "../../../../../../widgets/RouterPrompt/RouterPrompt";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { useContext } from "../../context";

export const LeaveConfirm = () => {
  const { tSettings: t } = useAppTranslation.Settings({ keyPrefix: "survey" });
  const { isStateChanged } = useContext();

  return (
    <RouterPrompt
      whenFn={isStateChanged}
      title={t("confirm.leave.title")}
      text={t("confirm.leave.text")}
    />
  );
};
